import { useContext, useEffect, useState } from "react"
import DropdownComponent from "../../components/dropdown/dropdown.component"
import { THEMES } from "../../constants"
import "./settings.page.css"
import API from "../../api"
import { SettingsContext } from "../../cells-bin"
import useAnimateIn from "../../hooks/useAnimateIn"

const SettingsPage = (props) => {
  const { user } = props
  const [preferences, setPreferences] = useState()
  const settings = useContext(SettingsContext)

  useAnimateIn()

  useEffect(() => {
    if (!settings) return

    const selectedTheme = THEMES.find(
      (t) => t.key === settings?.preferences?.theme
    )

    setPreferences({ theme: selectedTheme })
  }, [settings])

  const handlePreferenceUpdate = async (val) => {
    // Update page
    document.documentElement.className = ""
    document.documentElement.classList.add(`theme-${val.key}`)

    // Update context
    settings.setSettings({ ...settings, preferences: { theme: val.key } })

    // Update in API
    try {
      await API.makePostRequest(user, "users", {
        preferences: { theme: val.key },
      })
    } catch (e) {
      console.error(e)

      // todo handle
    }
  }

  return (
    <div className="cb-page">
      <div className="cb-page-header">
        <h4>
          <span className="icon-sliders" /> Settings
        </h4>
      </div>
      <div className="cb-page-content cb-settings-page">
        <div className="cb-settings-header">
          <h3>Preferences</h3>
          <p>Manage your preferences</p>
        </div>
        <div className="cb-settings-item">
          <h6>Theme</h6>
          <DropdownComponent
            options={THEMES}
            value={preferences?.theme}
            onChange={handlePreferenceUpdate}
          />
        </div>
      </div>
    </div>
  )
}

export default SettingsPage
